/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feature_Unavailable_MessageInputs */

const en_feature_unavailable_message = /** @type {(inputs: Feature_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This feature is not enabled for your environment. Please contact your administrator if you believe this is an error.`)
};

const nl_feature_unavailable_message = /** @type {(inputs: Feature_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze functie is niet ingeschakeld voor uw omgeving. Neem contact op met uw beheerder als u denkt dat dit een fout is.`)
};

/**
* | output |
* | --- |
* | "This feature is not enabled for your environment. Please contact your administrator if you believe this is an error." |
*
* @param {Feature_Unavailable_MessageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const feature_unavailable_message = /** @type {((inputs?: Feature_Unavailable_MessageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_Unavailable_MessageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_feature_unavailable_message(inputs)
	return en_feature_unavailable_message(inputs)
});